import { ISliderFieldModel } from "./ISliderFieldModel";
import { INIT_FORM_FIELD } from "../../formField/FormField_init";
import { FormFieldType } from "../../formField/FormFieldTypes";

export const INIT_SLIDER_FIELD: Partial<ISliderFieldModel> = {
    ...INIT_FORM_FIELD,
    type: FormFieldType.Slider
}